import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { SHAPE_MAX_SIDE_OPTIONS, ShapeQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two perimeter-and-area dials (ADR 0038 §1).
 *
 * Largest side bounds the sides a rectangle is built from. It does not bound
 * the area, which is a product of two of them - the same reading ADR 0028 §4
 * had to correct itself into for algebra.
 */
export function ShapeSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: ShapeQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, ShapeQuestion: value });
    }

    function handleMaxSideChange(event) {
        setSettings({ ...settings, ShapeMaxSide: Number(event.target.value) });
    }

    return (
        <div className="shapeSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.ShapeQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(ShapeQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.longestSideLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.longestSideAria')}>
                {SHAPE_MAX_SIDE_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`shapeMaxSide-${option}`}
                            value={option}
                            checked={settings.ShapeMaxSide === option}
                            onChange={handleMaxSideChange}
                        />
                        <label htmlFor={`shapeMaxSide-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ShapeSettings;
